import React from 'react';
import {FormattedMessage} from 'react-intl';

export const genericErrorMessage = 'alerts.AN_ERROR_OCCURRED';

export const envelopeCreationError = {
    'ANCHOR_TAB_STRING_NOT_FOUND': <FormattedMessage id={'alerts.ANCHOR_TAB_STRING_NOT_FOUND'}/>,
    'GENERIC_ERROR': <FormattedMessage id={'alerts.GENERIC_ERROR'}/>,
    'INVALID_EMAIL_ADDRESS_FOR_RECIPIENT': <FormattedMessage id={'alerts.INVALID_EMAIL_ADDRESS_FOR_RECIPIENT'}/>
};

export const duplicateSignerError = <FormattedMessage id={'alerts.DUPLICATE_SIGNER_ERROR'}/>;

export const mandatoryFieldsForSignerError = <FormattedMessage id={'alerts.MANDATORY_FIELD_FOR_SIGNER_ERROR'}/>;

export const duplicateEmailMobileSignerError = <FormattedMessage id={'alerts.DUPLICATE_EMAIL_MOBILE_SIGNER_ERROR'}/>;

export const duplicateEmailMobileSignerErrorLegalCompliance = <FormattedMessage id={'alerts.DUPLICATE_EMAIL_MOBILE_SIGNER_LEGAL_COMPLIANCE'}/>;


export const envelopeReviewBlankPageMessage = {
    'NO_SIGNER_DOCUMENT_SELECTED_MESSAGE': <FormattedMessage id={'alerts.NO_SIGNER_OR_DOCUMENT_SELECTED'}/>,
    'NO_SIGNER_DOCUMENT_SELECTED_ACTION': <FormattedMessage id={'alerts.NO_SIGNER_DOCUMENT_SELECTED_ACTION'}/>,
    'NO_SIGNER_SELECTED': <FormattedMessage id={'alerts.NO_SIGNER_SELECTED'}/>,
    'NO_DOCUMENT_SELECTED': <FormattedMessage id={'alerts.NO_DOCUMENT_SELECTED'}/>

};

export const noSignedDocumentsAvailable = 'alerts.NO_SIGNED_DOCUMENTS_AVAILABLE';


export const countryInfo = {
    ES: {
        'locale': 'es_ES',
        getIsdCode: () => '+34',
        getCountryName: () => 'labels.SPAIN'
    },
    DE: {
        'locale': 'de_DE',
        getIsdCode: () => '+49',
        getCountryName: () => 'labels.GERMANY'
    },
    UK: {
        'locale': 'en_GB',
        getIsdCode: () => '+44',
        getCountryName: () => 'labels.UNITED_KINGDOM'
    },
    GB: {
        'locale': 'en_GB',
        getIsdCode: () => '+44',
        getCountryName: () => 'labels.UNITED_KINGDOM'
    },
    PT: {
        'locale': 'pt_PT',
        getIsdCode: () => '+351',
        getCountryName: () => 'labels.PORTUGAL'
    }
}

export const EXCLUDE_ALFA_CASE_STATUS = ['Proposed', 'Quote', 'Submitted'];
export const excludeAlfaCaseStatusErrorMessage = 'alerts.EXCLUDE_ALFA_CASE_STATUS_ERROR_MESSAGE';
export const docusignErrorCodes = ['ANCHOR_TAB_STRING_NOT_FOUND', 'INVALID_EMAIL_ADDRESS_FOR_RECIPIENT', 'PHONE_NUMBER_INVALID', 'INVALID_EMAIL_ADDRESS'];

export const labelsForGermanProducts = {
    'DPFR - 24 month Loan Stock DE': 'products.DPFR_24_MONTH_LOAN_STOCK_DE',
    'DPFR - Loan DE': 'products.DPFR_LOAN_DE',
    'DPFR - Loan Stock DE': 'products.DPFR_LOAN_STOCK_DE',
    'DPFR - Non Full Payout Lease DE': 'products.DPFR_NON_FULL_PAYOUT_LEASE_DE',
    'DPFR - Operating Lease DE': 'products.DPFR_OPERATING_LEASE_DE',
    'Loan DE': 'products.LOAN_DE',
    'Non Full Payout Lease DE': 'products.NON_FULL_PAYOUT_LEASE_DE',
    'Operating Lease DE': 'products.OPERATING_LEASE_DE'
}

export const CONTRATO_STRING = 'CONTRATO';
export const SPAIN_COUNTRY_CODE = 'ES';
export const GERMANY_COUNTRY_CODE = 'DE';
export const UK_COUNTRY_CODE = 'UK';
export const PORTUGAL_COUNTRY_CODE = 'PT';
